import { render, staticRenderFns } from "./EventAvailabilityCard.vue?vue&type=template&id=64acb2bc&scoped=true"
import script from "./EventAvailabilityCard.vue?vue&type=script&lang=js"
export * from "./EventAvailabilityCard.vue?vue&type=script&lang=js"
import style0 from "./EventAvailabilityCard.vue?vue&type=style&index=0&id=64acb2bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64acb2bc",
  null
  
)

export default component.exports